import { render, staticRenderFns } from "./changeSf.vue?vue&type=template&id=6761d8e3&scoped=true"
import script from "./changeSf.vue?vue&type=script&lang=js"
export * from "./changeSf.vue?vue&type=script&lang=js"
import style0 from "./changeSf.vue?vue&type=style&index=0&id=6761d8e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6761d8e3",
  null
  
)

export default component.exports